<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
    <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>

    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Elegí un comercio</h1>
    </div>

    <div class="p-2 pl-2 help" (click)="toggleHelp()">
      <i class="bi bi-info-circle"></i>
    </div>
  </div>

  @if (showHelp()) {
    <div class="row m-3 p-3 align-items-center" id="tooltip-pwa" style="display:flex;">
      <div class="col-auto"><i class="bi bi-info-circle" style="font-size: 1.8em;"></i></div>
      <div class="col">{{ helpText() }}</div>
      <div class="col-auto" (click)="toggleHelp()"><i class="bi bi-x-lg" style="font-size: 1.4em;"></i></div>
    </div>
  }

  <a (click)="cambiarUbicacion()">
    <div class="fade-in col col-sm-12 tag-row ms-1 ms-lg-0 me-1 ps-lg-1 alerts-rows ps-0 pe-0 ms-4 me-4 mb-sm-2 mb-3 mt-4 cursor-pointer">
      <div class="row align-items-center pt-1 pb-1 p-sm-3">
        <div class="col-auto pe-0"><i class="bi bi-geo-alt dir-icon"></i></div>

        <div class="col alerts-row-text">
          @if (hasUbicacionDefault()) {
            <div class="dir-row-text-description text-start">
              {{ ubicacionDefaultTexto() }}
            </div>
          } @else {
            <div class="dir-row-text-description link-letras text-start">
              Agregá nueva dirección
            </div>
          }
        </div>

        <div class="col-auto"><i class="bi bi-chevron-right dir-icon"></i></div>
      </div>
    </div>
  </a>

  <div class="row-cols-12 m-2">

    <div class="mapa-wrapper position-relative">
      <!-- Spinner overlay (local) -->
      @if (loading()) {
        <div class="spinner-overlay fade-in">
          <div class="spinner-border text-info color-spinner" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      }

      <!-- Mapa -->
      @if (hasUbicacionDefault()) {
        <div class="row mb-4 mt-4 m-2 text-start">
          <div class="mapa" #divMap id="map" [class.mapa-opaco]="loading()"></div>
        </div>
      }
    </div>

    @if (!hasUbicacionDefault()) {
      <div class="alert alert-warning mt-2" role="alert">
        <small>Debe agregar una dirección para continuar</small>
      </div>
    }

    <div [hidden]="error().length == 0" class="alert alert-danger mt-2" role="alert">
      <small>{{ error() }}</small>
    </div>

    @if (hasUbicacionDefault()) {
      <div class="row-cols-12 mt-3">
        <div class="text-p p-3" style="font-weight: bold; font-size: 1.3em;">
          Comercios cercanos
        </div>
      </div>
    }

    @if (!loading()) {
      <div class="resultSearch mb-3 pb-3">
        @if (comercioUbicacionHorarios().length == 0) {
          <div class="row p-3 align-items-center alert alert-info ms-4 me-4">
            No se encontraron comercios cercanos
          </div>
        }

        @for (comUbiHor of comercioUbicacionHorarios(); track comUbiHor.id_ubicacion) {
          <a
            (click)="saveComercio(comUbiHor.id_ubicacion)"
            class="hiddenList ubicacioneslistadas mb-2"
            [class.active]="isActiveUbicacion(comUbiHor.id_ubicacion)"
          >
            <div class="row col-12 ps-3 pt-2 pb-1 align-items-center">
              <div class="col">
                <div class="row">
                  <div class="col-auto text-title-item pe-0">
                    {{ comUbiHor.comercio?.x_nombre_fantasia }}
                  </div>

                  <a
                    [routerLink]="['/perfil-comercio', comUbiHor.comercio?.id]"
                    class="col-auto pe-0"
                    title="Ver perfil"
                    (click)="$event.stopPropagation()"
                  >
                    <i class="bi bi-info-circle"></i>
                  </a>

                  @if (comUbiHor.n_max_porcentaje_descuento_comercio) {
                    <div class="col-auto rounded-pill bg-primary text-light d-flex ms-2 discount-shop">
                      <span class="me-1 small">hasta</span>
                      {{ comUbiHor.n_max_porcentaje_descuento_comercio }}% off
                    </div>
                  }
                </div>

                <div class="col text-detail-item">
                  {{ comUbiHor.ubicacion.x_domicilio }}
                </div>

                <div class="badges">
                  <span class="me-1 small">
                    <i
                      class="col-auto bi bi-clock pe-0"
                      [ngClass]="comUbiHor.b_abierto ? 'text-success' : 'text-danger'"
                      [title]="comUbiHor.b_abierto ? 'Abierto' : 'Cerrado'"
                    >
                      {{ comUbiHor.b_abierto ? 'Abierto' : 'Cerrado' }}
                    </i>
                  </span>

                  @if (comUbiHor.comercio?.b_envios) {
                    <span class="me-1 small">
                      <img class="icon-mercadopago" src="./assets/img/delivery.png" title="Hace Envíos">
                      Envíos
                    </span>
                  }

                  @if (comUbiHor.comercio?.b_mercadopago) {
                    <img class="icon-mercadopago" src="./assets/img/mercado-pago-letras.png" title="Mercado Pago">
                  }
                </div>
              </div>

              <div class="col-auto ms-auto">
                <i class="bi bi-chevron-right align-middle"></i>
              </div>
            </div>
          </a>
        }
      </div>
    }
  </div>
</div>
